var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-view"},[_c('div',{staticClass:"dialog"},[_c('h2',[_vm._v("确定要退出登录吗？")]),_vm._v(" "),_c('h3',[_vm._v("退出登录将导致个人中心无法使用")]),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('button',{on:{"click":_vm.logout}},[_vm._v("确定")]),_vm._v(" "),_c('button',{staticClass:"cancel",on:{"click":_vm.close}},[_vm._v("取消")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-456f782b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/logout-dialog.vue
// module id = null
// module chunks = 